import { useEffect, useState } from "react";
import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  useEffect(() => { document.title = "Contact — KKashigari India"; window.scrollTo(0, 0); }, []);

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return toast.error("Please fill all fields");
    toast.success("Thank you — we'll be in touch shortly");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div data-testid="contact-page" className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12 lg:py-16">
      <div className="mb-12">
        <div className="uplabel mb-3">Get In Touch</div>
        <h1 className="font-serif text-5xl sm:text-6xl text-[var(--bronze)]">We'd Love To Hear From You</h1>
      </div>
      <div className="grid lg:grid-cols-2 gap-16">
        <div>
          <div className="space-y-8">
            {[
              [MapPin, "Visit Our Flagship", "KKashigari Haveli, Hauz Khas Village, New Delhi 110016"],
              [Mail, "Email Us", "care@kkashigari.in"],
              [Phone, "Call Us", "+91 98100 00000 · Mon–Sat, 10am–7pm"],
              [Clock, "Store Hours", "Monday to Saturday · 11:00 AM – 8:00 PM"],
            ].map(([Icon, label, val]) => (
              <div key={label} className="flex gap-4">
                <div className="w-11 h-11 shrink-0 border border-[var(--line)] grid place-items-center text-[var(--olive)]"><Icon className="w-5 h-5" strokeWidth={1.4} /></div>
                <div>
                  <div className="uplabel text-[0.62rem] mb-1">{label}</div>
                  <div className="text-[var(--bronze)]">{val}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-12 p-8 bg-[#F3EECB]">
            <h3 className="font-serif text-2xl text-[var(--bronze)]">Shipping & Returns</h3>
            <ul className="mt-4 space-y-2 text-sm text-[var(--olive)] leading-relaxed">
              <li>· Free shipping on all orders above ₹2999.</li>
              <li>· Easy 7-day returns & exchanges on unworn pieces.</li>
              <li>· Cash on Delivery available across India.</li>
              <li>· Dispatch within 24–48 hours of order confirmation.</li>
            </ul>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Name</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Email</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          <div>
            <label className="uplabel text-[0.62rem] block mb-1.5">Message</label>
            <textarea rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message"
              className="w-full bg-transparent border border-[var(--line)] px-4 py-3 outline-none text-[var(--bronze)] focus:border-[var(--olive)] transition-colors" />
          </div>
          <button type="submit" data-testid="contact-submit" className="btn-primary uplabel px-8 py-4">Send Message</button>
        </form>
      </div>
    </div>
  );
}
